import { Navigate } from "react-router-dom";
import { pipGetAccessToken } from "../utils/pip";
import { pageRoutes } from "../routes/pageRoutes";
const PrivateRoute = ({ children }) => {
  const isAuth = pipGetAccessToken();
  return isAuth ? children : <Navigate to={pageRoutes?.login} />;
};

export default PrivateRoute;
